/* @ts-ignore */
import * as Types from '../generated/graphql.g';

import { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
import { useQuery, useInfiniteQuery, useMutation, UseQueryOptions, UseInfiniteQueryOptions, InfiniteData, UseMutationOptions } from '@tanstack/react-query';

function fetcher<TData, TVariables>(query: TypedDocumentString<unknown, unknown>, variables?: TVariables) {
  return async (): Promise<TData> => {
    const res = await fetch(import.meta.env.VITE_API_URL_GRAPHQL as string, {
    method: "POST",
    ...({"credentials":"include","headers":{"Content-Type":"application/json"}}),
      body: JSON.stringify({ query, variables }),
    });

    const json = await res.json();

    if (json.errors) {
      const { message } = json.errors[0];

      throw new Error(message);
    }

    return json.data;
  }
}
export type NotificationFragment = { __typename: 'NotificationType', id: string, notificationType?: Types.NotificationEnum | null, resolvedAt?: string | null, archivedAt?: string | null, acknowledgedAt?: string | null, autotaskTicketId?: string | null, createdAt: string, updatedAt: string, client?: { __typename: 'ClientType', id: string, name: string } | null, application?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', primaryApplication?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } } } | null } | null } | null, employee?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resolvedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, archivedBy?: { __typename: 'UserType', id: string, name: string } | null, acknowledgedBy?: { __typename: 'UserType', id: string, name: string } | null, fileUpload?: { __typename: 'ClientEmployeeFileUploadType', id: string, fileName: string, uploadSize: number, mimetype: string } | null, sharedCredential?: { __typename: 'ClientApplicationCredentialType', id: string, value: string } | null };

export type UnresolvedNotificationsTotalCountQueryVariables = Types.Exact<{
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
  notificationType_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.NotificationEnum>> | Types.InputMaybe<Types.NotificationEnum>>;
}>;


export type UnresolvedNotificationsTotalCountQuery = { __typename: 'Query', notifications?: { __typename: 'NotificationTypeConnection', totalCount?: number | null } | null };

export type NotificationsQueryVariables = Types.Exact<{
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  before?: Types.InputMaybe<Types.Scalars['String']['input']>;
  after?: Types.InputMaybe<Types.Scalars['String']['input']>;
  first?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  last?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  id?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  id_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  notificationType?: Types.InputMaybe<Types.NotificationEnum>;
  notificationType_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.NotificationEnum>> | Types.InputMaybe<Types.NotificationEnum>>;
  clientId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  clientId_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  applicationId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  applicationId_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  employeeId?: Types.InputMaybe<Types.Scalars['UUID']['input']>;
  employeeId_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  resolvedAt_Isnull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  resolvedAt_Gte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  resolvedAt_Lte?: Types.InputMaybe<Types.Scalars['DateTime']['input']>;
  resolvedById?: Types.InputMaybe<Types.Scalars['ID']['input']>;
  resolvedById_In?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['ID']['input']>> | Types.InputMaybe<Types.Scalars['ID']['input']>>;
  acknowledgedAt_Isnull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  archivedAt_Isnull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  executedAt_Isnull?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
  application_Resource_ProductName_Icontains?: Types.InputMaybe<Types.Scalars['String']['input']>;
  sortBy?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type NotificationsQuery = { __typename: 'Query', notifications?: { __typename: 'NotificationTypeConnection', totalCount?: number | null, edges: Array<{ __typename: 'NotificationTypeEdge', node?: { __typename: 'NotificationType', id: string, notificationType?: Types.NotificationEnum | null, resolvedAt?: string | null, archivedAt?: string | null, acknowledgedAt?: string | null, autotaskTicketId?: string | null, createdAt: string, updatedAt: string, client?: { __typename: 'ClientType', id: string, name: string } | null, application?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', primaryApplication?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } } } | null } | null } | null, employee?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resolvedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, archivedBy?: { __typename: 'UserType', id: string, name: string } | null, acknowledgedBy?: { __typename: 'UserType', id: string, name: string } | null, fileUpload?: { __typename: 'ClientEmployeeFileUploadType', id: string, fileName: string, uploadSize: number, mimetype: string } | null, sharedCredential?: { __typename: 'ClientApplicationCredentialType', id: string, value: string } | null } | null } | null>, pageInfo: { __typename: 'PageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } } | null };

export type ResolveNotificationMutationVariables = Types.Exact<{
  input: Types.ResolveNotificationMutationInput;
}>;


export type ResolveNotificationMutation = { __typename: 'Mutation', resolveNotification?: { __typename: 'ResolveNotificationMutation', notification?: { __typename: 'NotificationType', id: string, notificationType?: Types.NotificationEnum | null, resolvedAt?: string | null, archivedAt?: string | null, acknowledgedAt?: string | null, autotaskTicketId?: string | null, createdAt: string, updatedAt: string, client?: { __typename: 'ClientType', id: string, name: string } | null, application?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, notes?: string | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } }, resourceGroupApplications?: { __typename: 'ResourceGroupApplicationsType', primaryApplication?: { __typename: 'ClientApplicationType', id: string, reviewState: Types.TenantedClientApplicationReviewStateChoices, managedBy?: Types.TenantedClientApplicationManagedByChoices | null, supportedBy?: Types.TenantedClientApplicationSupportedByChoices | null, businessOwner?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resource: { __typename: 'ApplicationResourceType', id: string, productName?: string | null, publicResource: { __typename: 'ResourceType', signedLogoUrl?: string | null } } } | null } | null } | null, employee?: { __typename: 'ClientEmployeeType', id: string, name: string } | null, resolvedBy?: { __typename: 'UserType', id: string, name: string, email: string } | null, archivedBy?: { __typename: 'UserType', id: string, name: string } | null, acknowledgedBy?: { __typename: 'UserType', id: string, name: string } | null, fileUpload?: { __typename: 'ClientEmployeeFileUploadType', id: string, fileName: string, uploadSize: number, mimetype: string } | null, sharedCredential?: { __typename: 'ClientApplicationCredentialType', id: string, value: string } | null } | null, errors?: Array<{ __typename: 'ErrorType', field?: string | null, message?: string | null } | null> | null } | null };


export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const NotificationFragmentDoc = new TypedDocumentString(`
    fragment Notification on NotificationType {
  id
  client {
    id
    name
  }
  application {
    id
    reviewState
    managedBy
    supportedBy
    notes
    businessOwner {
      id
      name
    }
    resource {
      id
      productName
      publicResource {
        signedLogoUrl
      }
    }
    resourceGroupApplications {
      primaryApplication {
        id
        reviewState
        managedBy
        supportedBy
        businessOwner {
          id
          name
        }
        resource {
          id
          productName
          publicResource {
            signedLogoUrl
          }
        }
      }
    }
  }
  employee {
    id
    name
  }
  notificationType
  resolvedBy {
    id
    name
    email
  }
  resolvedAt
  archivedBy {
    id
    name
  }
  archivedAt
  acknowledgedBy {
    id
    name
  }
  acknowledgedAt
  autotaskTicketId
  fileUpload {
    id
    fileName
    uploadSize
    mimetype
  }
  sharedCredential {
    id
    value
  }
  createdAt
  updatedAt
}
    `, {"fragmentName":"Notification"});
export const UnresolvedNotificationsTotalCountDocument = new TypedDocumentString(`
    query UnresolvedNotificationsTotalCount($clientId: UUID, $after: String, $first: Int, $before: String, $last: Int, $offset: Int, $sortBy: String, $notificationType_In: [NotificationEnum]) {
  notifications(
    clientId: $clientId
    resolvedAt_Isnull: true
    after: $after
    first: $first
    before: $before
    last: $last
    offset: $offset
    sortBy: $sortBy
    notificationType_In: $notificationType_In
  ) {
    totalCount
  }
}
    `);

export const useUnresolvedNotificationsTotalCountQuery = <
      TData = UnresolvedNotificationsTotalCountQuery,
      TError = unknown
    >(
      variables?: UnresolvedNotificationsTotalCountQueryVariables,
      options?: Omit<UseQueryOptions<UnresolvedNotificationsTotalCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<UnresolvedNotificationsTotalCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<UnresolvedNotificationsTotalCountQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['UnresolvedNotificationsTotalCount'] : ['UnresolvedNotificationsTotalCount', variables],
    queryFn: fetcher<UnresolvedNotificationsTotalCountQuery, UnresolvedNotificationsTotalCountQueryVariables>(UnresolvedNotificationsTotalCountDocument, variables),
    ...options
  }
    )};

useUnresolvedNotificationsTotalCountQuery.getKey = (variables?: UnresolvedNotificationsTotalCountQueryVariables) => variables === undefined ? ['UnresolvedNotificationsTotalCount'] : ['UnresolvedNotificationsTotalCount', variables];

export const useInfiniteUnresolvedNotificationsTotalCountQuery = <
      TData = InfiniteData<UnresolvedNotificationsTotalCountQuery>,
      TError = unknown
    >(
      variables: UnresolvedNotificationsTotalCountQueryVariables,
      options: Omit<UseInfiniteQueryOptions<UnresolvedNotificationsTotalCountQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<UnresolvedNotificationsTotalCountQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<UnresolvedNotificationsTotalCountQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['UnresolvedNotificationsTotalCount.infinite'] : ['UnresolvedNotificationsTotalCount.infinite', variables],
      queryFn: (metaData) => fetcher<UnresolvedNotificationsTotalCountQuery, UnresolvedNotificationsTotalCountQueryVariables>(UnresolvedNotificationsTotalCountDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteUnresolvedNotificationsTotalCountQuery.getKey = (variables?: UnresolvedNotificationsTotalCountQueryVariables) => variables === undefined ? ['UnresolvedNotificationsTotalCount.infinite'] : ['UnresolvedNotificationsTotalCount.infinite', variables];


useUnresolvedNotificationsTotalCountQuery.fetcher = (variables?: UnresolvedNotificationsTotalCountQueryVariables) => fetcher<UnresolvedNotificationsTotalCountQuery, UnresolvedNotificationsTotalCountQueryVariables>(UnresolvedNotificationsTotalCountDocument, variables);

export const NotificationsDocument = new TypedDocumentString(`
    query Notifications($offset: Int, $before: String, $after: String, $first: Int, $last: Int, $id: ID, $id_In: [ID], $notificationType: NotificationEnum, $notificationType_In: [NotificationEnum], $clientId: UUID, $clientId_In: [ID], $applicationId: UUID, $applicationId_In: [ID], $employeeId: UUID, $employeeId_In: [ID], $resolvedAt_Isnull: Boolean, $resolvedAt_Gte: DateTime, $resolvedAt_Lte: DateTime, $resolvedById: ID, $resolvedById_In: [ID], $acknowledgedAt_Isnull: Boolean, $archivedAt_Isnull: Boolean, $executedAt_Isnull: Boolean, $application_Resource_ProductName_Icontains: String, $sortBy: String) {
  notifications(
    offset: $offset
    before: $before
    after: $after
    first: $first
    last: $last
    id: $id
    id_In: $id_In
    notificationType: $notificationType
    notificationType_In: $notificationType_In
    clientId: $clientId
    clientId_In: $clientId_In
    applicationId: $applicationId
    applicationId_In: $applicationId_In
    employeeId: $employeeId
    employeeId_In: $employeeId_In
    resolvedAt_Isnull: $resolvedAt_Isnull
    resolvedAt_Gte: $resolvedAt_Gte
    resolvedAt_Lte: $resolvedAt_Lte
    resolvedById: $resolvedById
    resolvedById_In: $resolvedById_In
    acknowledgedAt_Isnull: $acknowledgedAt_Isnull
    archivedAt_Isnull: $archivedAt_Isnull
    executedAt_Isnull: $executedAt_Isnull
    application_Resource_ProductName_Icontains: $application_Resource_ProductName_Icontains
    sortBy: $sortBy
  ) {
    edges {
      node {
        ...Notification
      }
    }
    pageInfo {
      ...PageInfo
    }
    totalCount
  }
}
    fragment Notification on NotificationType {
  id
  client {
    id
    name
  }
  application {
    id
    reviewState
    managedBy
    supportedBy
    notes
    businessOwner {
      id
      name
    }
    resource {
      id
      productName
      publicResource {
        signedLogoUrl
      }
    }
    resourceGroupApplications {
      primaryApplication {
        id
        reviewState
        managedBy
        supportedBy
        businessOwner {
          id
          name
        }
        resource {
          id
          productName
          publicResource {
            signedLogoUrl
          }
        }
      }
    }
  }
  employee {
    id
    name
  }
  notificationType
  resolvedBy {
    id
    name
    email
  }
  resolvedAt
  archivedBy {
    id
    name
  }
  archivedAt
  acknowledgedBy {
    id
    name
  }
  acknowledgedAt
  autotaskTicketId
  fileUpload {
    id
    fileName
    uploadSize
    mimetype
  }
  sharedCredential {
    id
    value
  }
  createdAt
  updatedAt
}
fragment PageInfo on PageInfo {
  hasNextPage
  hasPreviousPage
  startCursor
  endCursor
}`);

export const useNotificationsQuery = <
      TData = NotificationsQuery,
      TError = unknown
    >(
      variables?: NotificationsQueryVariables,
      options?: Omit<UseQueryOptions<NotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<NotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<NotificationsQuery, TError, TData>(
      {
    queryKey: variables === undefined ? ['Notifications'] : ['Notifications', variables],
    queryFn: fetcher<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables),
    ...options
  }
    )};

useNotificationsQuery.getKey = (variables?: NotificationsQueryVariables) => variables === undefined ? ['Notifications'] : ['Notifications', variables];

export const useInfiniteNotificationsQuery = <
      TData = InfiniteData<NotificationsQuery>,
      TError = unknown
    >(
      variables: NotificationsQueryVariables,
      options: Omit<UseInfiniteQueryOptions<NotificationsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseInfiniteQueryOptions<NotificationsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useInfiniteQuery<NotificationsQuery, TError, TData>(
      (() => {
    const { queryKey: optionsQueryKey, ...restOptions } = options;
    return {
      queryKey: optionsQueryKey ?? variables === undefined ? ['Notifications.infinite'] : ['Notifications.infinite', variables],
      queryFn: (metaData) => fetcher<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, {...variables, ...(metaData.pageParam ?? {})})(),
      ...restOptions
    }
  })()
    )};

useInfiniteNotificationsQuery.getKey = (variables?: NotificationsQueryVariables) => variables === undefined ? ['Notifications.infinite'] : ['Notifications.infinite', variables];


useNotificationsQuery.fetcher = (variables?: NotificationsQueryVariables) => fetcher<NotificationsQuery, NotificationsQueryVariables>(NotificationsDocument, variables);

export const ResolveNotificationDocument = new TypedDocumentString(`
    mutation ResolveNotification($input: ResolveNotificationMutationInput!) {
  resolveNotification(input: $input) {
    notification {
      ...Notification
    }
    errors {
      ...Error
    }
  }
}
    fragment Notification on NotificationType {
  id
  client {
    id
    name
  }
  application {
    id
    reviewState
    managedBy
    supportedBy
    notes
    businessOwner {
      id
      name
    }
    resource {
      id
      productName
      publicResource {
        signedLogoUrl
      }
    }
    resourceGroupApplications {
      primaryApplication {
        id
        reviewState
        managedBy
        supportedBy
        businessOwner {
          id
          name
        }
        resource {
          id
          productName
          publicResource {
            signedLogoUrl
          }
        }
      }
    }
  }
  employee {
    id
    name
  }
  notificationType
  resolvedBy {
    id
    name
    email
  }
  resolvedAt
  archivedBy {
    id
    name
  }
  archivedAt
  acknowledgedBy {
    id
    name
  }
  acknowledgedAt
  autotaskTicketId
  fileUpload {
    id
    fileName
    uploadSize
    mimetype
  }
  sharedCredential {
    id
    value
  }
  createdAt
  updatedAt
}
fragment Error on ErrorType {
  field
  message
}`);

export const useResolveNotificationMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<ResolveNotificationMutation, TError, ResolveNotificationMutationVariables, TContext>) => {
    
    return useMutation<ResolveNotificationMutation, TError, ResolveNotificationMutationVariables, TContext>(
      {
    mutationKey: ['ResolveNotification'],
    mutationFn: (variables?: ResolveNotificationMutationVariables) => fetcher<ResolveNotificationMutation, ResolveNotificationMutationVariables>(ResolveNotificationDocument, variables)(),
    ...options
  }
    )};


useResolveNotificationMutation.fetcher = (variables: ResolveNotificationMutationVariables) => fetcher<ResolveNotificationMutation, ResolveNotificationMutationVariables>(ResolveNotificationDocument, variables);
